import type { WarrantyExtensionProductPrice } from '@/lib/service/warrantyExtensionProduct';
import { devError } from '@/lib/utils/devLog';

export async function fetchWarrantyExtensionProductPrice(
  locale: string
): Promise<WarrantyExtensionProductPrice | null> {
  try {
    const params = new URLSearchParams({ locale });
    const response = await fetch(`/api/service/warranty-extension-product?${params.toString()}`);

    if (!response.ok) {
      devError('[warrantyExtensionProductClient] request failed:', response.status);
      return null;
    }

    const json = await response.json();
    if (!json?.success || !json.data?.price) {
      return null;
    }

    const { amount, currency } = json.data.price;
    if (typeof amount !== 'number' || typeof currency !== 'string' || !currency) {
      return null;
    }

    return { amount, currency };
  } catch (error) {
    devError('[warrantyExtensionProductClient] request error:', error);
    return null;
  }
}
